import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/Logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.png";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from '../assets/img/nav-icon4.png';


export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
          <div className="social-icon">
                <a href="https://www.linkedin.com/in/ashish-gautam%E2%9A%A1%EF%B8%8F-b5b3a020a/" target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="" /></a>
                <a href="https://twitter.com/AshishGTAM" target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="" /></a>
                <a href="https://www.instagram.com/mr_ashuholic/" target="_blank" rel="noopener noreferrer"><img src={navIcon3} alt="" /></a>
                <a href="https://www.kaggle.com/ashishg2002" target="_blank" rel="noopener noreferrer"><img src={navIcon4} alt="" className="center"/></a>
              </div>
            <p>Copyright @Ashish_Gautam</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}